module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ge":{"title":"ჩემი ქულები","close":"დახურვა","hist":"დაგროვილი ქულების ისტორია ","btn_change":"ქულების გადაცვლა ","h_descr":"აღწერა","h_amount":"დარიცხული","h_total":"სულ"},"ua":{"title":"Мої бали","close":"Закрити","hist":"Історія:","btn_change":"Обміняти","h_descr":"Опис","h_amount":"Нараховано","h_total":"Всього"}}')
  delete Component.options._Ctor
}
